import React, { useState } from 'react';
import { API_BASE_URL } from '../config';
import './ProgramOutcomeUpload.css';

const ProgramOutcomeUpload = ({ adminToken, onBack }) => {
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);
    const [selectedProgram, setSelectedProgram] = useState(null);
    const [programs, setPrograms] = useState([]);
    const [loadingPrograms, setLoadingPrograms] = useState(false);
    const [isDragging, setIsDragging] = useState(false);

    React.useEffect(() => {
        const fetchPrograms = async () => {
            setLoadingPrograms(true);
            try {
                const response = await fetch(`${API_BASE_URL}/api/programs`, {
                    headers: {
                        'Authorization': `Bearer ${adminToken}`
                    }
                });
                if (response.ok) {
                    const data = await response.json();
                    setPrograms(data);
                }
            } catch (err) {
                console.error('Programlar yüklenirken hata:', err);
            } finally {
                setLoadingPrograms(false);
            }
        };
        if (adminToken) {
            fetchPrograms();
        }
    }, [adminToken]);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            setResult(null);
            setError(null);
        }
    };

    const handleUpload = async () => {
        if (!file) {
            setError('Lütfen bir Word dosyası seçin.');
            return;
        }

        if (!selectedProgram) {
            setError('Lütfen bir program seçin.');
            return;
        }

        setLoading(true);
        setError(null);
        setResult(null);

        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await fetch(`${API_BASE_URL}/api/programs/${selectedProgram}/program-outcomes/upload-word`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${adminToken}`
                },
                body: formData
            });

            const data = await response.json();

            if (response.ok) {
                setResult(data);
                setFile(null);
                const fileInput = document.querySelector('input[type="file"]');
                if (fileInput) fileInput.value = '';
            } else {
                setError(data.error || 'Dosya yüklenirken bir hata oluştu.');
            }
        } catch (err) {
            setError('Sunucuya bağlanırken bir hata oluştu.');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const DocIcon = () => (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="9" y1="13" x2="15" y2="13" />
            <line x1="9" y1="17" x2="15" y2="17" />
        </svg>
    );

    const UploadIcon = () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="17 8 12 3 7 8" />
            <line x1="12" y1="3" x2="12" y2="15" />
        </svg>
    );

    const AlertIcon = () => (
        <svg className="po-message__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
    );

    const CheckIcon = () => (
        <svg className="po-message__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
    );

    return (
        <div className="po-page">
            <div className="po-page-header">
                <button type="button" className="po-page-header__back" onClick={onBack}>
                    ← Geri
                </button>
                <h1 className="po-page-header__title">Program Çıktıları Yükleme</h1>
                <span className="po-page-header__subtitle">Yönetim Paneli · Word (.docx)</span>
            </div>

            <div className="po-container">
                <div className="po-card">
                    <div className="po-card__header">
                        <h2 className="po-card__title">Belge Yükleme</h2>
                    </div>
                    <div className="po-card__body">
                        <div style={{ marginBottom: 22 }}>
                            <label className="po-field-label" htmlFor="po-program-select">
                                Program Seçimi
                            </label>
                            {loadingPrograms ? (
                                <p className="po-loading-text">Programlar yükleniyor…</p>
                            ) : (
                                <select
                                    id="po-program-select"
                                    className="po-select"
                                    value={selectedProgram || ''}
                                    onChange={(e) => setSelectedProgram(e.target.value ? parseInt(e.target.value) : null)}
                                >
                                    <option value="">Program seçiniz…</option>
                                    {programs.map((program) => (
                                        <option key={program.id} value={program.id}>
                                            {program.name}
                                        </option>
                                    ))}
                                </select>
                            )}
                        </div>

                        <label
                            className={`po-dropzone ${isDragging ? 'is-active' : ''}`}
                            onDragOver={(e) => { e.preventDefault(); setIsDragging(true); }}
                            onDragLeave={() => setIsDragging(false)}
                            onDrop={(e) => {
                                e.preventDefault();
                                setIsDragging(false);
                                const dropped = e.dataTransfer.files && e.dataTransfer.files[0];
                                if (dropped && dropped.name.toLowerCase().endsWith('.docx')) {
                                    setFile(dropped);
                                    setResult(null);
                                    setError(null);
                                } else if (dropped) {
                                    setError('Lütfen .docx uzantılı bir Word dosyası seçin.');
                                }
                            }}
                        >
                            <span className="po-dropzone__icon"><DocIcon /></span>
                            <p className="po-dropzone__primary">
                                Word dosyasını buraya sürükleyin
                            </p>
                            <p className="po-dropzone__secondary">
                                veya seçmek için tıklayın · Yalnızca .docx
                            </p>
                            {file && <div className="po-dropzone__filename">{file.name}</div>}
                            <input type="file" accept=".docx" onChange={handleFileChange} />
                        </label>

                        <div className="po-actions">
                            <button
                                type="button"
                                className="po-button po-button--primary"
                                onClick={handleUpload}
                                disabled={!file || !selectedProgram || loading}
                            >
                                <UploadIcon />
                                {loading ? 'Yükleniyor…' : 'Program Çıktılarını Yükle'}
                            </button>
                        </div>

                        {error && (
                            <div className="po-message po-message--error" role="alert">
                                <AlertIcon />
                                <span><span className="po-message__title">Hata:</span>{error}</span>
                            </div>
                        )}

                        {result && (
                            <div className="po-message po-message--success" role="status">
                                <CheckIcon />
                                <span>
                                    <span className="po-message__title">Başarılı:</span>
                                    {result.message || 'Program çıktıları başarıyla yüklendi.'}
                                    {result.count && (
                                        <> Toplam <strong>{result.count}</strong> program çıktısı işlendi.</>
                                    )}
                                </span>
                            </div>
                        )}
                    </div>
                </div>

                <div className="po-card">
                    <div className="po-card__header">
                        <h2 className="po-card__title">Word Dosyası Yapısı</h2>
                    </div>
                    <div className="po-card__body">
                        <p style={{ margin: '0 0 14px', color: '#475569', fontSize: '0.9rem' }}>
                            Yüklenecek Word dosyasındaki Program Çıktıları tablosu aşağıdaki sütun yapısına sahip olmalıdır.
                        </p>
                        <ul className="po-format-list">
                            <li><strong>1. Sütun</strong> Sayı (No)</li>
                            <li><strong>2. Sütun</strong> Program Çıktısı</li>
                        </ul>
                        <div className="po-notes">
                            <p>· Tablo başlığında <strong>“PROGRAM ÇIKTILARI”</strong> veya <strong>“Program Çıktıları”</strong> ifadesi bulunmalıdır.</p>
                            <p>· İlk satır başlık satırı olarak değerlendirilir ve atlanır.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProgramOutcomeUpload;
